/* eslint-disable import/no-anonymous-default-export */
import { RoleShow } from './RoleShow';
import { RoleList } from './RoleList';
import { RoleEdit } from './RoleEdit';
import { RoleCreate } from './RoleCreate';
import { Role } from '@/types';

export default {
    list: RoleList,
    show: RoleShow,
    edit: RoleEdit,
    create: RoleCreate,
    recordRepresentation: (record: Role) =>
        record?.name
};
